{
  "dss": {
    "button": {
      "back": "Zurück",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "confirmDelete": "Ja, löschen",
      "continue": "Weiter",
      "logout": "Abmelden",
      "passwordReset": "Passwort zurücksetzen",
      "save": "Speichern",
      "verify": "Bestätigen"
    },
    "error": {
      "403": "Sie haben keinen Zugriff auf diese Seite.",
      "404": "Die gewünschte Seite wurde nicht gefunden.",
      "generic": "Ein Fehler ist aufgetreten. Bitte später erneut versuchen.",
      "throttling": "Zu viele Versuche. Dieser Vorgang ist für eine Weile blockiert.",
      "title": "Error",
      "title403": "Zugriff verweigert",
      "title404": "Seite nicht gefunden"
    },
    "footer": {
      "imprint": "Impressum",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Datenschutzbestimmungen",
      "terms": "Nutzungsbedingungen"
    },
    "label": {
      "CRMAccountNumber": "Kontonummer",
      "contact": "Kontakt",
      "email": "E-Mail",
      "faq": "FAQ",
      "female": "Frau",
      "firstname": "Vorname",
      "help": "Hilfe",
      "language": "Sprache",
      "lastname": "Nachname",
      "male": "Herr",
      "needHelp": "Brauchen Sie Hilfe?",
      "newPassword": "Neues Passwort",
      "newPassword2": "Neues Passwort bestätigen",
      "oldPassword": "Aktuelles Passwort",
      "organization": "Organisation",
      "password": "Passwort",
      "required": "Pflichtfeld",
      "salutation": "Anrede",
      "select": "Bitte auswählen"
    },
    "lang": {
      "de": "Deutsch"
    },
    "link": {
      "contact": "https://support.stihl.com/de-DE/websso-contact/",
      "faq": "https://support.stihl.com/de-DE/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Registrierung bestätigen",
        "wait": "Bitte warten Sie, bis die Kontobestätigung abgeschlossen ist."
      },
      "otp": {
        "btnResend": "Verifizierungscode erneut schicken",
        "msg": {
          "invalidOTP": "Ihr Einmal-Passwort ist ungültig.",
          "resendFail": "Der Verifizierungscode konnte nicht erneut gesendet werden. Bitte versuchen Sie es später noch einmal."
        },
        "spamDetail": "Schauen Sie in Ihren Posteingang bzw. Spam-Ordner nach einer E-Mail von STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "E-Mail nicht angekommen?",
        "subtitle": "Um Ihr Passwort zurückzusetzen, müssen Sie Ihre E-Mail-Adresse verifizieren.",
        "title": "Verifizieren Sie Ihr Konto",
        "txtVerifyMail": "Geben Sie den neuen Verifizierungscode ein, der an ihre E-Mail Adresse {email} geschickt wurde"
      },
      "personal": {
        "msg": {
          "noChange": "Es gibt keine Änderungen zu speichern.",
          "updateError": "Die Persönliche Informationen konnten nicht gespeichert werden.",
          "updated": "Die Persönliche Informationen wurden gespeichert.",
          "userLoadErr": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal!"
        },
        "secOrganization": "Organisation",
        "secPersonal": "Persönlich",
        "secSettings": "Bevorzugte Einstellungen",
        "title": "Persönliche Informationen"
      },
      "postPwSet": {
        "info": "Ab sofort können Sie ihr neues Passwort zum Anmelden verwenden.",
        "link_name": "Weiter zum Fachhändlerportal",
        "link_url": "https://b2bportal.stihl.de",
        "title": "Ihr Passwort ist zurückgesetzt"
      },
      "resetPW": {
        "title": "Setzen Sie Ihr Passwort zurück"
      },
      "security": {
        "2fa": {
          "availableMethods": "Verfügbare 2FA-Methoden:",
          "info": "Die Zwei-Faktor-Authentifizierung (2FA) ist ein Sicherheitsfeature, das Ihrem Konto eine zusätzliche Schutzebene hinzufügt. Es erfordert, dass Sie zwei Methoden zur Anmeldung verwenden, anstatt nur Benutzername und Passwort.",
          "method": {
            "email": "E-Mail",
            "emailDesc": "Empfangen Sie Einmalcodes per E-Mail, um Authentifizierungsanforderungen abzuschließen.",
            "oath": {
              "add": {
                "button": "Authenticator-App registrieren"
              }
            }
          }
        },
        "authenticator": "Authenticator-App",
        "infoFederatedAccount": "Dieses Konto wird vom Identitätsanbieter Ihrer Organisation verwaltet, daher kann das Passwort hier nicht geändert werden. Um Ihr Passwort zu ändern, melden Sie sich über die Anmeldeseite Ihrer Organisation an oder wenden Sie sich an Ihren IT-Administrator.",
        "lastUse": "Zuletzt verwendet am {0}.",
        "msg": {
          "invalidPassword": "Das alte Passwort ist nicht gültig.",
          "passwordAlreadyUsed": "Die letzte 5 Passwörter dürfen nicht wiederverwendet werden.",
          "pwUpdateError": "Das Passwort konnte nicht gespeichert werden.",
          "pwUpdated": "Das Passwort wurde geändert."
        },
        "noDevice": "Nicht konfiguriert",
        "oathAdd": {
          "appInfo": "Um den Anmeldevorgang bei STIHL zu vereinfachen, können Sie Authenticator Apps wie {0}, {1} oder {2}, etc. verwenden, um einmalige passwörter zu generieren, die als zweiter faktor während des anmeldevorgangs verwendet werden.<br/>Wenn Sie Ihr mobiles Gerät verloren oder vergessen haben, können Sie jederzeit auf den alten, per E-Mail zugesandten 2FA-Code zurückgreifen.<br/><br/>Bitte folgen Sie den nachstehenden Anweisungen, um Ihr 2FA-Verfahren auf Ihrem mobilen Gerät einzurichten.",
          "badCode": "Ungültiger Code, bitte versuchen Sie es erneut.",
          "error": "Beim Versuch, das Authentifizierungsgerät zu registrieren, ist ein Fehler aufgetreten.",
          "headScan": "1. Scannen Sie den QR-Code mit Ihrer Authenticator-App",
          "headVerify": "2. Überprüfen Sie den Code",
          "infoKey": "Setup-Schlüssel",
          "infoKeyTitle": "Ihr Zwei-Faktor-Geheimnis",
          "infoScanBottom": "Scannen nicht möglich? Sie können {0} verwenden, um Ihre Authenticator-App manuell zu konfigurieren.",
          "infoVerify": "Geben Sie den von Ihrer Authenticator-App generierten Code ein.",
          "success": "Ihr Authentifizierungsgerät wurde registriert. Sie können es jetzt zum Anmelden verwenden.",
          "title": "Registrieren Sie Ihr Zwei-Faktor-Authentifizierungsgerät"
        },
        "oathDelete": {
          "error": "Beim Versuch, das Authentifizierungsgerät zu löschen, ist ein Fehler aufgetreten.",
          "success": "Das Authentifizierungsgerät wurde gelöscht."
        },
        "passkeys": {
          "about": {
            "info1": "Passkeys sind Paare von kryptografischen Schlüsseln (ein öffentlicher Schlüssel und ein privater Schlüssel), die von einem Authentifikator, den Sie steuern, gespeichert werden. Der Authentifikator kann nachweisen, dass ein Benutzer anwesend ist und autorisiert ist, den Passkey zu verwenden. Authentifikatoren können die Autorisierung mit einer PIN, einem Code, biometrischen Daten oder einem Gerätepasswort nachweisen, abhängig von den Fähigkeiten und der Konfiguration des jeweiligen Authentifikators. Authentifikatoren gibt es in verschiedenen Formen, wie z. B. ein iPhone, ein Android-Gerät, Windows Hello, einen FIDO2-Hardware-Sicherheitsschlüssel oder einen Passwort-Manager.",
            "info2": "Wenn Sie sich mit einem Passkey bei STIHL anmelden, verwendet Ihr Authentifikator Kryptografie mit öffentlichen Schlüsseln, um Ihre Identität gegenüber STIHL zu beweisen, ohne den Passkey jemals zu senden. Passkeys sind an eine Website-Domain wie stihl-sso.com gebunden und erfordern eine sichere Verbindung, sodass der Webbrowser die Authentifizierung auf einer nachgeahmten Phishing-Website verweigert. Diese Eigenschaften machen Passkeys äußerst phishingsicher und viel schwieriger anzugreifen als SMS oder TOTP-2FA, die phishbar sind.",
            "info3": "Cloud-basierte Passkey-Dienste ermöglichen das Synchronisieren von Passkeys über Geräte hinweg (z. B. Apple-Geräte, Android-Geräte oder Passwort-Manager), sodass sie von mehreren Orten aus nutzbar und weniger leicht verloren gehen. Sobald Sie einen synchronisierten Passkey auf einem Gerät eingerichtet haben, steht dieser auf mehreren Geräten zur Verfügung, die denselben Dienst nutzen. Wenn Sie beispielsweise einen Passkey mit Ihrem iCloud-Konto über die Touch ID Ihres MacBook registrieren, können Sie diesen Passkey anschließend mit Ihrem Gesicht, Fingerabdruck, PIN oder Gerätepasswort auf mehreren Geräten verwenden, die mit demselben iCloud-Konto verbunden sind.",
            "title": "Über Passkeys"
          },
          "add": {
            "button": "Neuen Passkey hinzufügen",
            "error": "Beim Versuch, den neuen Passkey hinzuzufügen, ist ein Fehler aufgetreten.",
            "success": "Ein neuer Passkey wurde hinzugefügt."
          },
          "delete": {
            "button": "Passkey löschen",
            "error": "Beim Versuch, diesen Passkey zu löschen, ist ein Fehler aufgetreten.",
            "success": "Der Passkey wurde gelöscht."
          },
          "edit": {
            "error": "Beim Versuch, den Passkey-Namen zu speichern, ist ein Fehler aufgetreten.",
            "name": "Passkey-Name",
            "success": "Der Passkey-Name wurde aktualisiert.",
            "title": "Geben Sie Ihrem Passkey einen Namen, um ihn von anderen Passkeys zu unterscheiden"
          },
          "info": "Passkeys sind eine einfache und sichere Alternative zu Passwörtern. Sie validieren Ihre Identität mithilfe von Berührung, Gesichtserkennung, einem Gerätepasswort oder einer PIN.",
          "none": "Kein Passkey konfiguriert.",
          "reallyDelete": "Möchten Sie den Passkey wirklich löschen?",
          "registeredPasskeys": "Ihre registrierten Passkeys:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Möchten Sie das Authentifizierungsgerät wirklich löschen?",
        "secMFA": "Multi-Faktor-Authentifizierung",
        "secPwdChange": "Passwort ändern",
        "title": "Sign-in und Sicherheit"
      },
      "setPW": {
        "acceptTC": "Bitte bestätigen Sie unsere {terms} und lesen Sie unsere {privacy}",
        "killSSO": "Alle aktiven Sitzungen ungültig machen",
        "msg": {
          "tokenExpired": "Der Link oder Code für das Passwort ist abgelaufen. Bitte folgen Sie dem Link, um Ihr Passwort zurückzusetzen: {link}."
        },
        "privacy": "Datenschutzbestimmungen",
        "terms": "Nutzungsbedingungen",
        "title": "Neues Passwort eingeben"
      }
    },
    "validations": {
      "hasDigit": "Muss Ziffern beinhalten",
      "hasLowercase": "Muss Kleinbuchstaben beinthalten.",
      "hasSpecial": "Muss Sonderzeichen beinthalten: {chars}",
      "hasUppercase": "Muss Großbuchstaben beinhalten",
      "invalidCharacters": "Beinhaltet ungültige Zeichen",
      "maxLength": "Maximal {max} Zeichen erlaubt",
      "minLength": "Mindestens {min} Zeichen erforderlich",
      "notSameAsEmail": "Zu ähnlich zur E-Mail-Adresse",
      "onlyValidCharactersAllowed": "Es sind nur Buchstaben, Zahlen und Leerzeichen zulässig.",
      "required": "Pflichtfeld",
      "sameAsPassword": "Die Passwörter stimmen nicht überein!",
      "tcAccepted": "Bitte bestätigen Sie unsere AGBs.",
      "validEmail": "Invalide E-Mail-Adresse.",
      "validOTP": "Geben Sie bitte den Verifizierungscode ein."
    }
  }
}
